import { Icon } from '@neshane/blueberry';

import { CompanyHeader } from './CompanyHeader/CompanyHeader';
import { HelpButton } from './HelpButton/HelpButton';
import { ImpersonationOrganisationSwitcher } from './ImpersonationOrganisationSwitcher/ImpersonationOrganisationSwitcher';
import { Logo } from './Logo/Logo';
import styles from './VerticalNavigation.module.css';
import { NavigationProvider } from './NavigationContext';
import { ProfileEntry } from './ProfileEntry/ProfileEntry';
import { ReleaseDetailsLink } from './ReleaseDetailsLink/ReleaseDetailsLink';
import { SetupGuideNavigationItem } from './SetupGuideNavigationItem/SetupGuideNavigationItem';

import './VerticalNavigation.css';

export const VerticalNavigation = ({
  items,
  profileHref,
  setupGuideHref,
  helpHref,
  releaseHref,
  onLogout,
  className,
}) => {
  return (
    <NavigationProvider className={className}>
      <header className={styles.top}>
        <Logo />
        <CompanyHeader />
        <ImpersonationOrganisationSwitcher />
      </header>
      <div className={styles.content}>
        <ul className="flex flex-col gap-4">
          {items.map(({ name, component: Component }) => (
            <li key={name}>
              <Component />
            </li>
          ))}
        </ul>
      </div>
      <footer className={styles.footer}>
        <ul className="flex flex-col gap-4">
          <ReleaseDetailsLink href={releaseHref} />
          <li>
            <SetupGuideNavigationItem href={setupGuideHref} />
          </li>
          <HelpButton href={helpHref} />
          <li>
            <ProfileEntry href={profileHref} />
          </li>
          {onLogout && (
            <li>
              <button
                type="button"
                className="navigation-item h-40"
                onClick={onLogout}
              >
                <Icon
                  name="arrow-right-rectangle"
                  size="m"
                  aria-hidden="true"
                  className="shrink-0"
                />
                <span className="navigation-toggle-display grow">خروج</span>
              </button>
            </li>
          )}
        </ul>
      </footer>
    </NavigationProvider>
  );
};

export default VerticalNavigation;